import api from '@shared/services/api';
import { ApiResponse } from '@shared/types/api';
import { Organization, UpdateOrganizationDto } from '../types/organization.types';

/**
 * Service for managing organization operations
 */
export class OrganizationService {
  static BASE_URL = '/organizations';
  /**
   * Get organization information for the current user
   */
  static async getOrganization(): Promise<Organization> {
    const response = await api.get<ApiResponse<Organization>>(`${this.BASE_URL}/me`);
    return response.data.data;
  }

  /**
   * Update organization information
   */
  static async updateOrganization(data: UpdateOrganizationDto): Promise<Organization> {
    const response = await api.put<ApiResponse<Organization>>(`${this.BASE_URL}/me`, data);
    return response.data.data;
  }
}
